import { useEffect, useState } from "react";
import { mqttConnectionStatus } from "./ApiCall";

// Asks /connectionStatus whether the device is connected right now. The
// Device Status and Appliance Status tiles both use it, and their checks share
// one request (mqttConnectionStatus is shareInFlight).
//
// Only runs while `enabled`. It checks again whenever `recheckKey` changes -
// the tiles pass the day data, which is re-read on an appliance or date
// change and on Refresh.
//
// Returns { checking, connected }: connected is true/false once the device
// has answered, and undefined while checking, when disabled, or when the
// check failed - callers fall back to the day data's `connected` then.
export const useLiveConnection = (deviceId, enabled, recheckKey) => {
  // Keyed by device so a slow answer for the previous appliance is never
  // shown for this one.
  const [status, setStatus] = useState({});

  useEffect(() => {
    if (!enabled || !deviceId) return;
    let cancelled = false;
    setStatus({});
    mqttConnectionStatus(deviceId).then((res) => {
      if (!cancelled) setStatus({ deviceId, connected: res?.connected });
    });
    return () => {
      cancelled = true;
    };
  }, [enabled, deviceId, recheckKey]);

  const answered = enabled && !!deviceId && status.deviceId === deviceId;
  return {
    checking: enabled && !!deviceId && !answered,
    connected:
      answered && typeof status.connected === "boolean" ? status.connected : undefined,
  };
};
